<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.231 9.231">
		<path id="Pfad_4578" data-name="Pfad 4578" d="M7.3,9.348a1,1,0,0,0,1.414,0l.637-.636a1,1,0,0,0,0-1.414L7.082,5.027,9.353,2.759a1,1,0,0,0,0-1.414L8.718.708A1,1,0,0,0,7.3.707L5.032,2.975,2.764.7A1,1,0,0,0,1.349.7l-.637.636a1,1,0,0,0,0,1.414L2.98,5.025.709,7.293a1,1,0,0,0,0,1.414l.636.637a1,1,0,0,0,1.414,0L5.03,7.077Z" transform="translate(-0.416 -0.411)" fill="#707070" fill-rule="evenodd"/>
	</svg>
</template>
